import * as firebase from 'firebase'
import Vue from 'vue'



export default {
  state: {
    debug:false,
    exhibitModel:true,
    mapEdit:false,
    settingsClass:"settingsIcon",
    playerAll:false,
    
    playerName:"Matt",
    gameStatus:{
        adaIntroShown:false,
        activeWreck:null,
        currentPage:null
              },
    viewedDocs:[],
    knownDocs:["Doc-001","Doc-006","Doc-017"],
    scenes:[],
    wreckStatusDefault:{
            "bomber":{ knownDocs:["Doc-001"], viewedDocs:[],mapPoly:null,map:"Map-001",diveModel:null,photos:[],scannedItems:{},collectedItems:{},diveEvi:{}},
            "bermagui":{ knownDocs:["Doc-006"], viewedDocs:[],mapPoly:null,map:"Map-003",diveModel:null,photos:[],scannedItems:{},collectedItems:{},diveEvi:{} },
            "enterprise":{ knownDocs:["Doc-017"], viewedDocs:[],mapPoly:null,diveModel:null,photos:[],scannedItems:{},collectedItems:{},diveEvi:{} },
            "pandemonium":{ knownDocs:["Doc-030"], viewedDocs:[],mapPoly:null,diveModel:null,photos:[],scannedItems:{},collectedItems:{},diveEvi:{} },
            "sub":{ knownDocs:["Doc-022"], viewedDocs:[],mapPoly:null,diveModel:null,photos:[],scannedItems:{},collectedItems:{},diveEvi:{}},
            "verdoemd":{ knownDocs:["Doc-038"], viewedDocs:[] ,mapPoly:null,diveModel:null,photos:[],scannedItems:{},collectedItems:{},diveEvi:{}}
              },
    wreckStatus:{
            "bomber":{ knownDocs:["Doc-001"], viewedDocs:[],mapPoly:null,map:"Map-001",diveModel:null,photos:[],scannedItems:{},collectedItems:{},diveEvi:{}},
            "bermagui":{ knownDocs:["Doc-006"], viewedDocs:[] ,mapPoly:null,map:"Map-003",diveModel:null,photos:[],scannedItems:{},collectedItems:{},diveEvi:{}},
            "enterprise":{ knownDocs:["Doc-017"], viewedDocs:[],mapPoly:null ,diveModel:null,photos:[],scannedItems:{},collectedItems:{},diveEvi:{}},
            "pandemonium":{ knownDocs:["Doc-030"], viewedDocs:[],mapPoly:null ,diveModel:null,photos:[],scannedItems:{},collectedItems:{},diveEvi:{}},
            "sub":{ knownDocs:["Doc-022"], viewedDocs:[],mapPoly:null,diveModel:null ,photos:[],scannedItems:{},collectedItems:{},diveEvi:{}},
            "verdoemd":{ knownDocs:["Doc-038"], viewedDocs:[],mapPoly:null ,diveModel:null,photos:[],scannedItems:{},collectedItems:{},diveEvi:{}}
             }
             
  },
  mutations: {
    setSettingsClass(state,payload){
      state.settingsClass=payload
    },
    setDebug(state,payload){
      state.debug=payload
    },
    setExhibitModel(state,payload){
      state.exhibitModel=payload
    },
    setMapEdit(state,payload){
      state.mapEdit=payload
    },
    findScene(state,payload){
      if(!state.scenes.includes(payload.id)){
        state.scenes.push(payload.id)
        console.log("known Scenes",state.scenes)
      }
    },
    setPlayersAll(state,payload){
      state.playerAll=payload
    },
   setWreckInfo(state,payload){
      console.log("Set Wreck Info",payload)
     state.wreckStatus[payload.id]=payload.content
   },
   setKnownDocs(state,payload){
     console.log("----Set Known Docs",payload)
     if(state.gameStatus.activeWreck){
      state.wreckStatus[state.gameStatus.activeWreck].knownDocs=payload
     }
     //state.knownDocs=payload
   },
   setViewedDocs(state,payload){
    if(state.gameStatus.activeWreck){
     state.wreckStatus[state.gameStatus.activeWreck].viewedDocs=payload
    }
    
    //state.viewedDocs=payload
  },
  addPhoto(state,payload){
    if(state.gameStatus.activeWreck){
      console.log("PUSH TO", state.wreckStatus[state.gameStatus.activeWreck])
      state.wreckStatus[state.gameStatus.activeWreck].photos.push(payload)
      console.log(state.wreckStatus[state.gameStatus.activeWreck].photos)
    }
  },
  setWreckMapArea(state,payload){
    //alert("SET MAP AREA")
    //console.log("setWreckMapArea",payload)
    if(state.gameStatus.activeWreck){
      state.wreckStatus[state.gameStatus.activeWreck].mapPoly=[payload[0].lat,payload[0].lng,payload[1].lat,payload[1].lng,payload[2].lat,payload[2].lng,payload[3].lat,payload[3].lng]
      //state.wreckStatus[state.gameStatus.activeWreck].mapPoly={p1:payload[0],p2:payload[1],p3:payload[2],p4:payload[3]}
    }
  },
   setGameStatus(state,payload){
    state.gameStatus=payload
   },
   setWreckStatus(state,payload){
     if(payload){
      console.log("Set wreck status",payload)
      state.wreckStatus=payload
     }else{
       alert("WreckStatus Set to default")
      state.wreckStatus=state.wreckStatusDefault
     }
    
   },
   setViewedDocs(state,payload){
    state.viewedDocs=payload
   },
   readDoc(state,payload){
     console.log("---Read doc",payload)
    if(state.gameStatus.activeWreck){
      if(!state.wreckStatus[state.gameStatus.activeWreck].viewedDocs.includes(payload.id)){
        state.wreckStatus[state.gameStatus.activeWreck].viewedDocs.push(payload.id)
      }
    }
   },
   findDoc(state,payload){

    if(payload.id=="") {return}
     
    if(state.gameStatus.activeWreck){
      if(!state.wreckStatus[state.gameStatus.activeWreck].knownDocs.includes(payload.id)){
        state.wreckStatus[state.gameStatus.activeWreck].knownDocs.push(payload.id)
      }
    }
   }
  },
  actions: {
    applyUserData({commit},payload){
      if(payload.knownDocs){
        commit('setKnownDocs',payload.knownDocs)
        commit('setViewedDocs',payload.viewedDocs)
      }
      if(payload.gameStatus){
        commit('setGameStatus',payload.gameStatus)
      }
      if(payload.wreckStatus){
        commit('setWreckStatus',payload.wreckStatus)
      }
      commit('setIsTester',payload.tester)
    },
    resetWreck({commit},payload){
      let newData={ id:payload,
                    documents:[],
                    experts:[],
                    evidence:[],
                    locations:[]}
      commit('setWreckInfo',{id:payload,content:newData})
    }
  },
  getters: {
   getWreckPhotos(state,getters){
    if(getters.getWreck){
      return state.wreckStatus[getters.getWreck.id].photos
    }
   },
   getGameStatus(state){
     return state.gameStatus
   },
   getActiveWreckStatus(state,getters){
    
    if(state.gameStatus.activeWreck && state.wreckStatus){
      console.log("GETTIMNG ACTIVE WRECK FROM",state.gameStatus.activeWreck,state.wreckStatus)
      return state.wreckStatus[state.gameStatus.activeWreck]
    }
   },
   getActiveWreck(state){
     console.log("Getting getActiveWreck",state.gameStatus)
    if(state.gameStatus && state.gameStatus.activeWreck){
      return state.gameStatus.activeWreck
    }else{
      return null
    }
   },
   getWreckStatus(state){
     return state.wreckStatus
   },
   getWreckSearchArea(state,getters){
    if(getters.getWreck){
      console.log("MAP POLY",state.wreckStatus[getters.getWreck.id].mapPoly)
      return state.wreckStatus[getters.getWreck.id].mapPoly
    }
   },
   getKnownDocs(state,getters){
     if(getters.getWreck){
       return state.wreckStatus[getters.getWreck.id].knownDocs
     }
   },
   getViewedDocs(state,getters){
    if(getters.getWreck){
      return state.wreckStatus[getters.getWreck.id].viewedDocs
    }
   },
   getPlayerAll(state){
     return state.playerAll
   },
   getDebug(state){
     return state.debug
   },
   getExhibitModel(state){
    return state.exhibitModel
  },
  getMapEdit(state){
    return state.mapEdit
  },
  getSettingsClass(state){
    return state.settingsClass
  },
  }
}
